import {Heading, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {TimingBeltReplacementGroup} from '../../kit/groups/TimingBeltReplacementGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function TimingBeltReplacementSubSection() {
  return (
    <>
      <VFKit.SubSection data-testid="timing-belt-replacement">
        <VStack spacing={4}>
          <Heading size={4}>{i18n.t('entity.vehicle.labels.timingBelt')}</Heading>
          <VFKit.Group columns={4} data-testid="timing-belt-replacement-group">
            <TimingBeltReplacementGroup />
          </VFKit.Group>
        </VStack>
      </VFKit.SubSection>
    </>
  );
}
